
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./css/SideNav.css";
import logout from './images/power3.png'

import { DBContext } from './DBContext'
import { DineContext } from './DineContext'

function RightNavMob() {

    const { logginedDB , fetchData , rightNavState , rightNavStateFunc, logout } = useContext(DBContext);
    const { clearDineState } = useContext(DineContext);

    const navigate = useNavigate();

    const handleLogout = async () => {
        logout();
        clearDineState();
        navigate("/");
    };

    useEffect(() => {
        window.onpopstate = () => {
            if (!logginedDB) {
                navigate("/");
            }
        };
    }, [logginedDB]);

    const handleBackToBilling = () => {
        
    }

    return (
        <div className='w-max h-full flex flex-col border-none font-nunito z-[9999] transition-all duration-300 ease-in-out bg-[#f5f5f5] overflow-auto noScroll'>
            <div className={rightNavState ? 'w-max flex flex-col text-nowrap font-nunito' : 'hidden'} >
                <div className='w-full h-max sideNavMobBorderB  cursor-pointer transition-colors duration-300 ease-in flex items-center p-[.75rem] gap-2'
                    onClick={handleLogout}
                >
                    <img className="w-[1rem]" src={logout} alt="Dashboard" />
                    <span className="">Logout</span>
                </div>
            </div>
        </div>
    );
}

export default RightNavMob;
